import { useEffect, useState } from 'react';
import {
  formatCountdown,
  getRemainingSeconds,
  parseLastActiveDate,
  SESSION_WINDOW_SECONDS,
} from '../utils/sessionWindow';

export default function useSessionCountdown(lastActive, windowSeconds = SESSION_WINDOW_SECONDS) {
  const [remainingSeconds, setRemainingSeconds] = useState(() =>
    getRemainingSeconds(lastActive, windowSeconds)
  );

  useEffect(() => {
    const tick = () => setRemainingSeconds(getRemainingSeconds(lastActive, windowSeconds));
    tick();

    const parsed = parseLastActiveDate(lastActive);
    if (!parsed) return undefined;

    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [lastActive, windowSeconds]);

  return {
    remainingSeconds,
    isExpired: remainingSeconds === 0,
    formatted: remainingSeconds > 0 ? formatCountdown(remainingSeconds) : 'Expired',
  };
}
